import Urinals from './UrinalsContainer';

export default Urinals;
